import { createContext } from 'react';
import { Machine } from './Machine';

type TMachineContext = {
    machine: Machine | null;
    updateMachine: (machine: Machine | null) => void;
};

export const MachineContext = createContext<TMachineContext>({
    machine: null,
    updateMachine: () => {},
});
